<template>
  <!-- Coming soon page-->
  <div class="misc-wrapper">
    <b-link
      to="/"
      class="brand-logo"
    >
      <logo width="80%" />
      <!-- <h2 class="brand-text text-primary ml-1">
        {{ appName }}
      </h2> -->
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Pronto lanzaremos algo que te encantará 🚀
        </h2>
        <p class="mb-2">
          Próximamente estarás disfrutando de ésta sección
        </p>
        <b-button
          variant="primary"
          class="mb-3 btn-sm-block"
          to="/"
        >
          Volver al inicio
        </b-button>

        <b-img
          fluid
          :src="imgUrl"
          alt="Próximamente"
        />
      </div>
    </div>
  </div>
<!-- / Coming soon page-->
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BButton, BImg,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    Logo,
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/coming-soon.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  setup() {
    // App Name
    const { appName } = $themeConfig.app
    return { appName }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
